var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import StyleConfTemplate from '../StyleConfTemplate';
import { startMouseMove } from "../../../../../../lib/utils";
import SizeInput from '../widgets/sizeInput';
import { getNumber, getUnit } from './borderUtils';
import { COLOR_PICKER_INIT_VALUE } from '../../utils/constant';
import ColorPicker from "../../../../../../lib/builtin/components/ColorPicker/index";
import { isEqual } from "lodash-es";
import WRadio from "../../../../../../lib/builtin/components/Radio/index";
import WButton from "../../../../../../lib/builtin/components/Button";
const defaultShadow = () => ({
  color: 'black',
  offsetX: '0px',
  offsetY: '0px',
  inset: '',
  blur: '3px',
  size: '4px'
});
const shadowRadius = 50;
let BoxShadow = class BoxShadow extends Vue {
  constructor() {
    super(...arguments);
    this.openKey = '0';
    this.parsedShadowFields = []; // 这个是数学意义上的坐标
    this.currentDragCoor = {
      x: 0,
      y: 0
    };
  }
  get boxShadowOptions() {
    const h = this.$createElement;
    return [{
      label: h("div", ["\u7ECF\u5178"]),
      value: '#CBCBCBFF 3px 5px 7px 2px'
    }, {
      label: h("div", ["\u6241\u5E73"]),
      value: '#E7E5E5FF 4px 4px 3px -2px'
    }, {
      label: h("div", ["\u7ACB\u4F53"]),
      value: '#979797FF 1px 2px 4px 2px'
    }];
  }
  created() {
    this.$watch(() => this.borderFieldSetShadows, () => {
      const res = this.borderFieldSetShadows.map(item => {
        const {
          color,
          inset
        } = item;
        const [offsetX, offsetY, blurRadius = '0px', spreadRadius = '0px'] = item.coords;
        if (!color || !offsetX || !offsetY || !blurRadius || !spreadRadius) {
          return defaultShadow();
        }
        return {
          inset: inset ? 'inset' : '',
          offsetX,
          offsetY,
          blur: blurRadius,
          size: spreadRadius,
          color
        };
      });
      if (isEqual(res, this.parsedShadowFields)) return;
      this.parsedShadowFields = res;
    }, {
      deep: true,
      immediate: true
    });
  }
  handlerOpenKey() {
    this.currentDragCoor = {
      x: 0,
      y: 0
    };
  }
  stringifyShadow(el) {
    return `${el.color} ${el.offsetX} ${el.offsetY} ${el.blur} ${el.size} ${el.inset}`.trim();
  }
  handlerParsedShadowFields() {
    var _this$shadowPanelDiv;
    if ((_this$shadowPanelDiv = this.shadowPanelDiv) !== null && _this$shadowPanelDiv !== void 0 && _this$shadowPanelDiv.matches(':focus, :focus-within')) {
      this.commit();
    }
  }
  commit() {
    const res = this.parsedShadowFields.map(el => this.stringifyShadow(el)).join(', ');
    if (res.length) this.$emit('change', ['boxShadow', res]);else this.$emit('change', ['boxShadow', null]);
  }
  handleCircleMousedown(e) {
    this.updateDragCoor(e);
    document.addEventListener('mousemove', this.handleMousemove);
  }
  updateDragCoor(event) {
    var _this$$refs;
    const {
      clientX,
      clientY
    } = event;
    const {
      left,
      top
    } = (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs[`circle-${this.openKey}`]) === null || _this$$refs === void 0 ? void 0 : _this$$refs.getBoundingClientRect();
    const x = clientX - (left + shadowRadius);
    const y = clientY - (top + shadowRadius);
    const distance = Math.sqrt(x ** 2 + y ** 2);
    const boundedX = distance > shadowRadius ? shadowRadius / distance * x : x;
    const boundedY = distance > shadowRadius ? shadowRadius / distance * y : y;
    this.$set(this.currentField, 'offsetX', `${Math.floor(boundedX)}px`);
    this.$set(this.currentField, 'offsetY', `${Math.floor(boundedY)}px`);
  }
  handleMousemove(event) {
    this.updateDragCoor(event);
    startMouseMove({
      initialEvent: event,
      onMove: ({
        event
      }) => {
        this.updateDragCoor(event);
      },
      onEnd: async () => {
        document.removeEventListener('mousemove', this.handleMousemove);
      }
    });
  }
  handleAddBoxShadow() {
    this.parsedShadowFields = [...this.parsedShadowFields, defaultShadow()];
    this.openKey = `${this.parsedShadowFields.length - 1}`;
  }
  get currentField() {
    return this.parsedShadowFields[this.openKey] || {};
  }
  get maxOffset() {
    const x = +getNumber(this.currentField.offsetX);
    const y = +getNumber(this.currentField.offsetY);
    const distance = Math.sqrt(x ** 2 + y ** 2);
    const boundedX = distance > shadowRadius ? shadowRadius / distance * x : x;
    const boundedY = distance > shadowRadius ? shadowRadius / distance * y : y;
    return {
      x: boundedX,
      y: boundedY
    };
  }
  deleteShadow(index) {
    this.parsedShadowFields = this.parsedShadowFields.filter((_, i) => i !== index);
  }
  render() {
    const h = arguments[0];
    return h(StyleConfTemplate, {
      "attrs": {
        "name": "阴影",
        "changed": this.parsedShadowFields.length > 0
      },
      "on": {
        "reset": () => this.parsedShadowFields = []
      }
    }, [h("div", {
      "class": "uc-stylePanel-shadow",
      "ref": "shadowPanelDiv",
      "attrs": {
        "tabindex": "0"
      },
      "style": "outline: 0"
    }, [h("a-collapse", {
      "attrs": {
        "bordered": false,
        "accordion": true,
        "activeKey": this.openKey,
        "default-active-key": this.openKey,
        "destroyInactivePanel": true
      },
      "on": {
        "change": key => this.openKey = key
      }
    }, [this.parsedShadowFields.map((option, index) => h("a-collapse-panel", {
      "key": `${index}`,
      "attrs": {
        "showArrow": false
      }
    }, [h("div", {
      "slot": "header",
      "style": {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 5px',
        alignItems: 'center'
      }
    }, [h("div", [h("a-icon", {
      "attrs": {
        "rotate": `${index}` === this.openKey ? 90 : 0,
        "type": "caret-right"
      }
    }), h("span", {
      "style": {
        color: `${option.color}`,
        marginLeft: '10px'
      }
    }, [this.stringifyShadow(option)])]), h("a-icon", {
      "attrs": {
        "type": "close"
      },
      "on": {
        "click": () => this.deleteShadow(index)
      }
    })]), h("div", [h("div", {
      "style": {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, [h(StyleConfTemplate, {
      "attrs": {
        "name": "模式",
        "inline": true,
        "changed": option.inset !== ''
      },
      "on": {
        "reset": () => this.$set(this.currentField, 'inset', '')
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h("a-radio-group", {
      "attrs": {
        "value": option.inset,
        "button-style": "solid"
      },
      "on": {
        "change": e => this.$set(this.currentField, 'inset', e.target.value)
      }
    }, [h("a-radio-button", {
      "attrs": {
        "value": ''
      }
    }, [" \u5916\u90E8 "]), h("a-radio-button", {
      "attrs": {
        "value": 'inset'
      }
    }, [" \u5185\u90E8 "])])])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "颜色",
        "inline": true,
        "changed": option.color !== 'black'
      },
      "on": {
        "reset": () => this.$set(this.currentField, 'color', 'black')
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h("color-picker", {
      "attrs": {
        "placement": "topRight",
        "value": option.color || COLOR_PICKER_INIT_VALUE
      },
      "on": {
        "change": val => {
          this.$set(this.currentField, 'color', val);
          this.commit(); // 颜色选择器焦点在外部
        }
      }
    })])])]), h("div", {
      "class": "uc-stylePanel-shadow-angle"
    }, [h("div", {
      "class": "uc-stylePanel-shadow-angle-inputs"
    }, [h(StyleConfTemplate, {
      "attrs": {
        "name": 'x轴偏移',
        "inline": true,
        "changed": option.offsetX !== '0px'
      },
      "on": {
        "reset": () => this.$set(this.currentField, 'offsetX', '0px')
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "placeholder": "0",
        "unit": getUnit(option.offsetX),
        "value": getNumber(option.offsetX)
      },
      "on": {
        "change": e => this.$set(this.currentField, 'offsetX', e)
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": 'y轴偏移',
        "inline": true,
        "changed": option.offsetY !== '0px'
      },
      "on": {
        "reset": () => this.$set(this.currentField, 'offsetY', '0px')
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "placeholder": "0",
        "unit": getUnit(option.offsetY),
        "value": getNumber(option.offsetY)
      },
      "on": {
        "change": e => this.$set(this.currentField, 'offsetY', e)
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": '模糊',
        "inline": true,
        "changed": option.blur !== '3px'
      },
      "on": {
        "reset": () => this.$set(this.currentField, 'blur', '3px')
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "placeholder": "3",
        "value": getNumber(option.blur),
        "unit": getUnit(option.blur)
      },
      "on": {
        "change": e => this.$set(this.currentField, 'blur', e)
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": '扩展',
        "inline": true,
        "changed": option.size !== '4px'
      },
      "on": {
        "reset": () => this.$set(this.currentField, 'size', '4px')
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "placeholder": "4",
        "unit": getUnit(option.size),
        "value": getNumber(option.size)
      },
      "on": {
        "change": e => this.$set(this.currentField, 'size', e)
      }
    })])])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "角度",
        "inline": true,
        "changed": option.offsetX !== '0px' || option.offsetY !== '0px'
      },
      "on": {
        "reset": () => {
          this.$set(this.currentField, 'offsetX', '0px');
          this.$set(this.currentField, 'offsetY', '0px');
        }
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h("svg", {
      "attrs": {
        "height": 2 * shadowRadius,
        "width": 2 * shadowRadius
      },
      "on": {
        "mousedown": this.handleCircleMousedown,
        "mouseup": () => document.removeEventListener('mousemove', this.handleMousemove)
      }
    }, [h("circle", {
      "attrs": {
        "cx": shadowRadius,
        "cy": shadowRadius,
        "r": shadowRadius,
        "fill": "#f0f0f0"
      },
      "ref": `circle-${index}`
    }), h("circle", {
      "attrs": {
        "cx": shadowRadius + this.maxOffset.x,
        "cy": shadowRadius + this.maxOffset.y,
        "r": "5",
        "fill": `${option.color}` || '#FFF'
      }
    })]), h("svg", {
      "attrs": {
        "height": 2 * shadowRadius,
        "width": 2 * shadowRadius
      },
      "style": {
        position: 'absolute',
        pointerEvents: 'none'
      }
    }, [h("line", {
      "attrs": {
        "x1": "0",
        "y1": shadowRadius,
        "x2": 2 * shadowRadius,
        "y2": shadowRadius
      },
      "style": "stroke:rgb(200,200,200);stroke-width:1"
    }), h("line", {
      "attrs": {
        "x1": shadowRadius,
        "y1": "0",
        "x2": shadowRadius,
        "y2": 2 * shadowRadius
      },
      "style": "stroke:rgb(200,200,200);stroke-width:1"
    })])])])])])]))]), h("div", {
      "style": {
        display: 'flex'
      }
    }, [h(WRadio, {
      "attrs": {
        "with-solid-fill": true,
        "value": this.borderFieldSetShadows.length === 1 ? this.borderFieldSetShadows[0] : '',
        "options": this.boxShadowOptions
      },
      "on": {
        "change": val => this.$emit('change', ['boxShadow', val])
      }
    }), h(WButton, {
      "on": {
        "click": this.handleAddBoxShadow
      },
      "attrs": {
        "icon": "plus"
      }
    }, ["\u81EA\u5B9A\u4E49"])])])]);
  }
};
__decorate([Prop({
  required: true,
  type: Array
})], BoxShadow.prototype, "borderFieldSetShadows", void 0);
__decorate([Watch('openKey')], BoxShadow.prototype, "handlerOpenKey", null);
__decorate([Watch('parsedShadowFields', {
  deep: true
})], BoxShadow.prototype, "handlerParsedShadowFields", null);
__decorate([Ref('shadowPanelDiv')], BoxShadow.prototype, "shadowPanelDiv", void 0);
BoxShadow = __decorate([Component({
  name: 'BoxShadow',
  components: {
    ColorPicker,
    WRadio
  }
})], BoxShadow);
export default BoxShadow;
//# sourceMappingURL=boxShadow.js.map
